import React, { FunctionComponent } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { useRequiredValidation } from '../../../../../utils/form/validation.utils';
import { FormSmallTextInput } from '../../inputs/SmallTextInput';

import { IMeetingFolderFormProps } from './types';
import { ICreateMeetingFolder } from '../../../../../app/resource/meeting-shortcuts/meeting-shortcuts.types';
import { createMeetingFolder } from '../../../../../app/page/page-storage/meeting-folder/meeting-folder.actions';

export const MeetingFolderForm: FunctionComponent<IMeetingFolderFormProps> = () => {
  const dispatch = useDispatch();
  const formProps = useForm();

  const requiredValidation = useRequiredValidation();

  const onSubmit = ({ name }: ICreateMeetingFolder) => {
    dispatch(createMeetingFolder({ name }));
  };

  return (
    <FormProvider {...formProps}>
      <form
        id="meeting-folder-form"
        className=""
        onSubmit={formProps.handleSubmit((formData) => onSubmit((formData as unknown) as ICreateMeetingFolder))}
        method="post"
      >
        <div className="field-container">
          <FormSmallTextInput
            id="name"
            name="name"
            type="text"
            label="Folder name"
            placeholder="Enter folder name here..."
            validation={requiredValidation}
          />
        </div>
      </form>
    </FormProvider>
  );
};
